import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from 'Components/Base';

const QuizLayoutWrapper = ({ isDesktop, ...props }) => (
  <Flex
    mt={6}
    flexDirection={isDesktop ? 'row' : 'column'}
    mb={isDesktop ? 0 : 92}
    justifyContent="space-between"
    {...props}
  />
);

QuizLayoutWrapper.propTypes = {
  isDesktop: PropTypes.bool,
};

export default QuizLayoutWrapper;
